import CoachMarkIcon1 from "./CoachMarkIcon1.png"
import CoachMarkIcon2 from "./CoachMarkIcon2.png"
import CoachMarkIcon3 from "./CoachMarkIcon3.png"
import CoachMarkIcon4 from "./CoachMarkIcon4.png"

const CoachMarkIconIndex={
  CoachMarkIcon1,
  CoachMarkIcon2,
  CoachMarkIcon3,
  CoachMarkIcon4,
}

export default CoachMarkIconIndex